<nz-upload [(nzFileList)]="fileList" [nzBeforeUpload]="beforeUpload" [nzShowUploadList]="avatar ? false : true"
           [nzAccept]="accept.toString()" [nzListType]="avatar ? 'picture-card' : 'text'"
           [nzDisabled]="showIcons"
>
  <ng-container *ngIf="!imageUrl" >
    <div *ngIf="avatar">
          <span nz-icon nzType="upload" class="m-r-5"></span> Upload ảnh
    </div>

    <a *ngIf="!avatar" nz-button>
          <span nz-icon nzType="upload" class="m-r-5"></span> Upload ảnh
    </a>
  </ng-container>

  <div *ngIf="imageUrl" class="picture-card">
    <img
      *ngIf="imageUrl"
      [ngStyle]="stylePreview"
      [src]="imageUrl | secure | async"
    />
    <div [hidden]="previewVisible" nz-tooltip class="overlay" (mouseover)="showIcons = true"
         (mouseleave)="showIcons = false">
      <div class="action">
        <i class="icon delete-icon" nz-icon nzType="delete" (click)="removeImage()"></i>
        <i class="icon eye-icon m-l-5" nz-icon nzType="eye" (click)="viewImage()"></i>
      </div>
    </div>
  </div>

</nz-upload>

<nz-modal
  [nzVisible]="previewVisible"
  [nzContent]="modalContent"
  [nzFooter]="null"
  (nzOnCancel)="previewVisible = false"
  (nzAfterClose)="previewVisible = false"
>
  <ng-template #modalContent>
    <img [src]="previewImage" [ngStyle]="{ width: '100%' }"/>
  </ng-template>
</nz-modal>

